"use client";

import { useUser } from "@clerk/nextjs";
import EmbedCTASection from "./EmbedCTASection";

export default function AuthAwareEmbedCTA() {
  const { isSignedIn } = useUser();
  return <EmbedCTASection isAuthenticated={Boolean(isSignedIn)} />;
}
